import { StyledRibbonBadge } from './style';
import { RibbonBadgeProps } from './types';
import { EBadgePosition } from 'utils/enums';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

export const RibbonBadge = ({
  text,
  backgroundColor,
  textColor, // currently supporting only solid
  position,
  viewModel,
  isTextAutoResized,
  maxFontSizePx = 14,
}: RibbonBadgeProps) => {
  const renderCenterBadge = () => (
    <div className={'ac-ribbon-badge ac-ribbon-badge--center'}>
      <div className="ac-ribbon-badge__front">
        {isTextAutoResized ? (
          <AutoTextSize
            as="span"
            maxFontSizePx={maxFontSizePx}
            minFontSizePx={6}
            className="ac-ribbon-badge__front__text autotextSize"
          >
            {text}
          </AutoTextSize>
        ) : (
          <span className={'ac-ribbon-badge__front__text'}>{text}</span>
        )}
      </div>
      <div className="ribbon-edge ribbon-edge-left"></div>
      <div className="ribbon-edge ribbon-edge-right"></div>
    </div>
  );

  const renderCornerPositionBadge = () => (
    <div className={'ac-ribbon-badge ac-ribbon-badge--corner'}>
      <p className="ribbon-corner-text">{text.substring(0, 8)}</p>
    </div>
  );

  return (
    <StyledRibbonBadge
      bgColor={backgroundColor}
      textColor={textColor.colorOne}
      position={position}
    >
      {position === EBadgePosition.CENTER &&
      (viewModel === 'match' ||
        viewModel === 'candivore' ||
        viewModel === 'communix' ||
        viewModel === 'communix2' ||
        viewModel === 'play-simple')
        ? renderCenterBadge()
        : renderCornerPositionBadge()}
    </StyledRibbonBadge>
  );
};
